import { msg } from '@lit/localize';
import List from 'devextreme/ui/list';
/**
 * Create the inner menu/submenu structure
 */
export class DinapsisNavbarUserMenu {
    constructor(userkeycloak) {
        /**
         * Array of MenuItem to generate the inner content
         */
        this.menu = [];
        this.userkeycloak = userkeycloak;
        this.itemClick = this.itemClick.bind(this);
        this.menu = [
            {
                id: 'editar_usuario', text: `${msg('profile')}`, icon: 'material-icons account-circle', selected: false, children: [],
            },
            {
                id: 'change_password', text: `${msg('change_password')}`, icon: 'material-icons move-to-inbox', selected: false, children: [],
            },
            {
                id: 'logout', text: `${msg('logout')}`, icon: 'material-symbols-outlined material-icons cancel', selected: false, children: [],
            },
        ];
    }
    /**
     * "Create a new list element, create a new list,
     * set the list options, and return the list element."
     * Creates a new div element.
     * Creates a new list, passing in the div element.
     * Sets the list options.
     * Sets the list event handler.
     * @returns The listelement is being returned.
     */
    Render() {
        const listElement = document.createElement('div');
        const list = new List(listElement);
        list.option('elementAttr', { class: 'sidebarmenus dinapsis-user-menu' });
        list.option('items', this.menu);
        list.on('itemClick', this.itemClick);
        return listElement;
    }
    /**
     * If the itemIndex is 0, redirect to profile, if it's 1,
     *  to password, if it's 2, logout,
     * otherwise do nothing.
     * @param {any} e - any - the event object
     * @returns The return value of the switch statement.
     */
    itemClick(e) {
        switch (e.itemIndex) {
            case 0:
                return this.redirectToProfile();
            case 1:
                return this.redirectToPassword();
            case 2:
                return this.logout();
            default:
                return null;
        }
    }
    /**
     * Function that redirect to the user profile of plataforma
     */
    redirectToProfile() {
        var _a;
        (_a = this.userkeycloak) === null || _a === void 0 ? void 0 : _a.accountManagement();
    }
    /**
     * Function that redirect the user to change password
     */
    redirectToPassword() {
        var _a;
        (_a = this.userkeycloak) === null || _a === void 0 ? void 0 : _a.login({ action: 'UPDATE_PASSWORD' });
    }
    /**
     * Log out of the page
     */
    logout() {
        var _a, _b, _c;
        (_a = this.userkeycloak) === null || _a === void 0 ? void 0 : _a.logout();
        (_c = (_b = this.userkeycloak) === null || _b === void 0 ? void 0 : _b.onAuthLogout) === null || _c === void 0 ? void 0 : _c.call(null);
    }
}
//# sourceMappingURL=dinapsis-navbar-user-menu.js.map